import { environment } from '../environments/environment';

export const production = environment.production;
export const API_URL = '/api';
export const GOOGLE_MAPS_API_KEY = 'AIzaSyCTBxoe4lBV3OEdf_HCeg9mL8VfPjqEwbE'; // TODO including API key is a necessary evil for client-side Google Maps, look into using Google Maps API with signature
export const GOOGLE_MAPS_OPTIMIZE_CLIENT_ID =
  '192459502758-4ljtrigh8cdl1j1hcpp3kqhisldt666h.apps.googleusercontent.com';
export const GOOGLE_MAPS_OPTIMIZE_URL =
  'https://routeoptimization.googleapis.com/v1/projects/inpress-projecten:optimizeTours';
export const GOOGLE_MAPS_GEOCODE_URL =
  'https://maps.googleapis.com/maps/api/geocode/json?address=';
export const GOOGLE_MAPS_STREETVIEW_URL =
  'https://maps.googleapis.com/maps/api/streetview/metadata?location=';
export const MAX_UPLOAD_SIZE = 8388608; // nginx-templates/inpress.conf limits client request size to 10M; seems unlikely that image upload request excluding actual image is 2M, so 8M should be plenty
export const DO_CHECK_DEBOUNCE_TIME = 250;
export const DEFAULT_DEBOUNCE_TIME = 500;
export const INVOICE_PRICE_DISPLAY_DEBOUNCE_TIME = DEFAULT_DEBOUNCE_TIME;
export const RENDER_CHILDREN_DELAY = 100;
export const INT_MAX_SIGNED_32_BIT_VALUE = Math.pow(2, 31) - 1;
export const EXPIRED_OFFLINE_ITEM_REMOVAL_INTERVAL = 1800000; // 30 minutes
export const EMPTY_OBJECT = {};
export const newPortalUrl = environment.newPortalUrl;
